import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import {
  sendOTP,
  onlyVerifyOTP,
  registerUser,
} from "../../../../redux/zservices/BasicAPIFunctions"; // Assuming sendOTP and onlyVerifyOTP are correctly implemented
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import { getProfile } from "../../../../redux/profile/action";
import ResisterLoaderButton from "../../../Common/Loader/ResisterLoaderButton";
import { disabledStyle } from "../../../Common/ClickDisable";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";

const validationSchema = Yup.object().shape({
  emailotp: Yup.string()
    .matches(/^\d{6}$/, "Email OTP must be exactly 6 digits")
    .required("Email OTP is required"),
  mobileotp: Yup.string()
    .matches(/^\d{6}$/, "Mobile OTP must be exactly 6 digits")
    .required("Mobile OTP is required"),
});

const VerifyEmailMobile = ({ valuess, setNextpage }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lan, setLan] = useState(localStorage.getItem("laung") ?? "en");
  const [emailVerified, setEmailVerified] = useState(false);
  const [mobileVerified, setMobileVerified] = useState(false);
  const values = valuess;
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  const initialValues = {
    emailotp: "",
    mobileotp: "",
  };

  const [timeLeft, setTimeLeft] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [timeLeft1, setTimeLeft1] = useState(60);
  const [canResend1, setCanResend1] = useState(false);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, []);

  useEffect(() => {
    if (!timeLeft) {
      setCanResend(true);
      return;
    }
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  useEffect(() => {
    if (!timeLeft1) {
      setCanResend1(true);
      return;
    }
    const intervalId = setInterval(() => {
      setTimeLeft1(timeLeft1 - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft1]);

  const sendEmailOTP = () => {
    setLoading(true);
    setTimeLeft(60);
    setCanResend(false);
    const data = {
      email_id: values?.email_id,
    };

    sendOTP(data)
      .then((res) => {
        if (res.data.status) {
          urtoast(res.data.response?.message, 1);
        } else {
          urtoast(res.data.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(e?.message, 2);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      });
  };
  const sendMobileOTP = () => {
    setLoading(true);
    setTimeLeft1(60);
    setCanResend1(false);
    const data = {
      mobile_number: values?.mobile_number,
      country_code: values?.country_code,
    };

    sendOTP(data)
      .then((res) => {
        if (res.data.status) {
          urtoast(res.data.response?.message, 1);
        } else {
          urtoast(res.data.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(e?.message, 2);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      });
  };
  const verifyEmailOTP = (emailotp) => {
    setLoading(true);
    const data = {
      email_id: values?.email_id,
      otp: emailotp,
    };
    onlyVerifyOTP(data)
      .then((res) => {
        if (res.data.status) {
          urtoast(res.data.response?.message, 1);
          setEmailVerified(true);
        } else {
          urtoast(res.data.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(e?.message, 2);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      });
  };

  const verifyMobileOTP = (mobileotp) => {
    setLoading(true);

    const data = {
      mobile_number: values?.mobile_number,
      country_code: values?.country_code,
      otp: mobileotp,
    };
    onlyVerifyOTP(data)
      .then((res) => {
        if (res.data.status) {
          urtoast(res.data.response?.message, 1);
          setMobileVerified(true);
        } else {
          urtoast(res.data.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(e?.message, 2);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      });
  };
  const handleSubmit = () => {
    setLoading(true);
    registerUser(values)
      .then((res) => {
        if (res.data.status) {
          localStorage.setItem("urexperttoken", res.data.response.token);
          localStorage.setItem("role_type", res.data.response.role_type);
          dispatch(getProfile());
          navigate(`/${lan}/registrationsuccessful`);
          urtoast(res.data.response?.message, 1);
          window.location.reload()
        } else if (!res.data.status) {
          setLoading(false);
          urtoast(res?.data?.response?.message, 2);
        }
      })
      .catch((e) => {
        setLoading(false);
        urtoast(e?.message, 2);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      });
  };

  useEffect(() => {
    if (mobileVerified && emailVerified) {
      handleSubmit();
    }
  }, [mobileVerified, emailVerified]);

  return (
    <div className="mx-auto register email">
      <img
        className="mail-img"
        src={`${CloudStorage.cloudurl}/Assets/Images/common/otp.svg`}
        alt=""
      />
      <h1>Verify Email and Mobile number</h1>
      <p>
        OTP has been sent to the mobile number{" "}
        <strong>
          {values?.country_code} {values?.mobile_number}{" "}
        </strong>
        and email ID <strong>{values?.email_id}</strong>
        <span>Please verify the OTPs.</span>
      </p>
      <a
        style={loading ? disabledStyle : {}}
        onClick={() => {
          if (!emailVerified || !mobileVerified) {
            setNextpage(true);
          }
        }}
      >
        Change email or Mobile no.
      </a>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form>
            <div className="col-md-11 mx-auto form-sec">
              <div className="row">
                <div className="col-md-12 form-group">
                  <label htmlFor="email">Email</label>
                  <div className="password-btn">
                    <Field
                      disabled={emailVerified}
                      type="text"
                      id="emailotp"
                      name="emailotp"
                      className="form-control"
                      placeholder="Enter OTP From Email"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setFieldValue("emailotp", value);
                        }
                      }}
                    />

                    <button
                      disabled={emailVerified || !values?.emailotp}
                      style={{ color: emailVerified ? "green" : "" }}
                      type="button"
                      className="btn"
                      onClick={() => {
                        verifyEmailOTP(values?.emailotp);
                      }}
                    >
                      {emailVerified ? "Verified" : "Verify"}
                    </button>
                  </div>
                  <ErrorMessage
                    name="emailotp"
                    component="div"
                    className="error"
                  />
                </div>

                <div className="col-md-12 form-group">
                  <label htmlFor="mobile_number">Mobile Number</label>
                  <div className="password-btn">
                    <Field
                      disabled={mobileVerified}
                      type="text"
                      id="mobileotp"
                      name="mobileotp"
                      className="form-control"
                      placeholder="Enter OTP From Mobile No."
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setFieldValue("mobileotp", value);
                        }
                      }}
                    />

                    <button
                      disabled={mobileVerified || !values.mobileotp}
                      style={{ color: mobileVerified ? "green" : "" }}
                      type="button"
                      className="btn"
                      onClick={() => {
                        verifyMobileOTP(values?.mobileotp);
                      }}
                    >
                      {mobileVerified ? "Verified" : "Verify"}
                    </button>
                  </div>
                  <ErrorMessage
                    name="mobileotp"
                    component="div"
                    className="error"
                  />
                </div>

                <div className="col-md-12 last-form">
                  {/* {emailVerified && mobileVerified && (
                    <>
                      <button
                        className="btn create-account"
                        type="submit"
                        disabled={!(emailVerified && mobileVerified)}
                      >
                        {loading ? (
                          <>
                            <i className="fa-solid fa-spinner fa-spin"></i> Loading
                          </>
                        ) : (
                          "Continue"
                        )}
                      </button>
                    </>
                  )} */}
                  {emailVerified && mobileVerified ? (
                    ""
                  ) : (
                    <p>
                      <span
                        onClick={() => {
                          setLoading(true);
                        }}
                      >
                        Haven’t received the OTP?
                      </span>
                    </p>
                  )}
                  <p className="d-flex flex-wrap" style={{rowGap:'10px'}}>
                    {emailVerified == true ? (
                      ""
                    ) : (
                      <a
                        type="text"
                        disabled={emailVerified}
                        style={loading ? disabledStyle : {}}
                        className={`login-password ${emailVerified ? "disabled-link" : ""
                          }`}
                        onClick={sendEmailOTP}
                      >
                        {canResend
                          ? "Resend Email OTP"
                          : `Resend Email OTP in: ${timeLeft} seconds`}
                      </a>
                    )}
                    {emailVerified == true || mobileVerified == true ? "" : "|"}
                    {mobileVerified == true ? (
                      ""
                    ) : (
                      <a
                        type="text"
                        style={loading ? disabledStyle : {}}
                        className={`login-password ${mobileVerified ? "disabled-link" : ""
                          }`}
                        disabled={mobileVerified}
                        onClick={sendMobileOTP}
                      >
                        {canResend1
                          ? "Resend Mobile OTP"
                          : `Resend Mobile OTP in: ${timeLeft1} seconds`}
                      </a>
                    )}
                  </p>
                  {(emailVerified == true && mobileVerified == true) &&
                    <div className="col-md-12 form-group">
                      <p>Loading...</p>
                    </div>
                  }
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default VerifyEmailMobile;
